<template>
    <div class="link-word-modal">
        <TitleBaseBox :title="title" @close="close" @confirm="confirmClick">
            <div class="link-word-content">
                <div class="link-word-name" v-if="!data.hideWord">
                    <div class="link-word-text">
                        {{wordLabel}}
                        <el-tooltip class="item" effect="dark" :content="wordTips" placement="top">
                            <i class="el-icon-info" />
                        </el-tooltip>
                    </div>
                    <div class="link-word-show" :style="{ color: currentColor }">{{word}}</div>
                </div>
                <div class="link-word-name">
                    <div class="link-word-text">{{linkTypeLabel}}</div>
                    <div class="link-radio-choose">
                        <RadioGroup :space="40" :radios="linkTypeSettings" @change="radioChange"/>
                    </div>
                </div>
                <div class="link-word-name">
                    <div class="link-word-text">{{linkLabel}}</div>
                    <LinkInput 
                        ref="validLinkInput"
                        class="link-word-input" 
                        :placeholder="inputLinkLabel" 
                        :minHeight="linkInputMinHeight"
                        :init-value="url"
                        :cmd-param="data.urlCmd"
                        :url-type="urlType"
                        @inputChange="wordChange"
                        @input="urlChange"/>
                </div>
                <div class="link-word-name" v-if="isShowLinkOpenType">
                    <div class="link-word-text">{{linkOpenTypeLabel}}</div>
                    <div class="link-radio-choose">
                        <RadioGroup :radios="linkOpenTypeSetting" @change="linkOpenRadioChange"/>
                    </div>
                </div>
                <div class="link-word-delete" v-show="data.type === 'update'" @click="deleteLink">
                    <Icon :width="16" :height="18" bgPosition="-96px 0" hoverBgPosition="-96px -22px" class="link-delete-icon" />
                    {{deleteLabel}}
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import LinkInput from "../questionEdit/answers/widgets/LinkInput.vue";
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import RadioGroup from "@/views/zhiji/bComponents/checks/RadioGroup";
import { uniqueId } from '@/views/zhiji/js/common/util.js';

export default {
    name: "LinkWordEditModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        LinkInput,
        Icon,
        RadioGroup,
    },
    data() {
        return {
            title: this.$t("zhiji.knowlege.linkWordModal.title"),
            wordLabel: this.$t("zhiji.knowlege.linkWordModal.wordLabel"),
            wordTips: this.$t("zhiji.knowlege.linkWordModal.wordTips"),
            linkTypeLabel: this.$t("zhiji.knowlege.linkWordModal.linkTypeLabel"),
            linkLabel: this.$t("zhiji.knowlege.linkWordModal.linkLabel"),
            deleteLabel: this.$t("zhiji.knowlege.linkWordModal.deleteLabel"),
            inputWordLabel: this.$t("zhiji.knowlege.linkWordModal.inputWordLabel"),
            inputLinkLabel: this.$t("zhiji.knowlege.linkWordModal.inputLinkLabel"),
            word: "",
            url: this.data.url || "",
            urlType: this.data.colorType || "outColor",
            linkTypeRadios: [{
                label: this.$t("zhiji.knowlege.linkWordModal.linkTypeRadiosOne"),
                value: "outColor",
                checked: true,
            }, {
                label: this.$t("zhiji.knowlege.linkWordModal.linkTypeRadiosTwo"),
                value: "innerColor",
                checked: false,
            }],
            linkNewTxt: {},
            linkInputMinHeight: '60px',
            linkOpenTypeLabel: this.$t("zhiji.knowlege.linkWordModal.linkOpenTypeLabel"),
            linkOpenTypeRadios: [{
                label: this.$t("zhiji.knowlege.linkWordModal.embedded"),
                value: "iframe",
                checked: true,
            }, {
                label: this.$t("zhiji.knowlege.linkWordModal.newPage"),
                value: "newPage",
                checked: false,
            }],
            linkOpenType: 'iframe',
            pageType: this.data.newPage,
        }
    },
    computed: {
        linkTypeSettings() {
            let colorType = this.data.colorType;

            if(colorType == "innerColor") {
                this.setCheckedLink("innerColor");
            } else {
                this.setCheckedLink("outColor");
            }

            return this.linkTypeRadios;
        },
        linkOpenTypeSetting() {
            let newPage = this.data.newPage;
            if (newPage === 'new_page') {
                this.setCheckedOpenType('newPage');
                this.linkOpenType = 'newPage';
            } else {
                this.setCheckedOpenType('iframe');
                this.linkOpenType = 'iframe';
            }

            return this.linkOpenTypeRadios;
        },
        // 当前链接文字颜色
        currentColor() {
            switch (this.urlType) {
                case 'outColor':
                    return this.data.colorData.outColor;
                case 'innerColor':
                    return this.data.colorData.innerColor;
                default:
                    return null;
            }
        },
        // 链接类型为外部网页时显示链接打开方式
        isShowLinkOpenType () {
            return this.urlType === 'outColor';
        },
    //  title (){
    //  return  this.$t("zhiji.knowlege.linkWordModal.title")
    //  }
    },
    mounted() {
        // 过滤最外层中括号
        this.word = this.data.word;
    },
    methods: {
        close() {
            this.data.cancel && this.data.cancel({})
            this.$emit('closeModal');
        },
        wordChange(newVal) {
            this.word = newVal;
        },
        urlChange(newVal) {
            this.url = newVal.text || '';
            newVal.uId = this.data.uId || uniqueId();
            newVal.type = this.data.type || 'text';
            this.linkNewTxt = newVal;
        },
        setCheckedLink(linkType) {
            let outColor = this.linkTypeRadios[0];
            let innerColor = this.linkTypeRadios[1];

            outColor.checked = false;
            innerColor.checked = false;

            linkType === 'innerColor' ? this.linkTypeRadios.splice(1, 1, { ...innerColor, checked: true })
            : this.linkTypeRadios.splice(0, 1, { ...outColor, checked: true });
        },
        setCheckedOpenType(openType) {
            let iframe = this.linkOpenTypeRadios[0];
            let newPage = this.linkOpenTypeRadios[1];

            iframe.checked = false;
            newPage.checked = false;

            openType === 'newPage' ? this.linkOpenTypeRadios.splice(1, 1, { ...newPage, checked: true })
            : this.linkOpenTypeRadios.splice(0, 1, { ...iframe, checked: true });
        },
        getUrlTtype() {
            for(const type in this.data.colorData) {
                if(type === this.urlType) {
                    return {
                        colorType: type,
                        color: this.data.colorData[type],
                    };
                }
            }
        },
        confirmClick() {
            if(!this.url) {
                this.$store.dispatch('zhiji/showModal', {
                    type: 'MessageModal',
                    data: {
                        type: 'error',
                        message: this.$t("zhiji.knowlege.linkWordModal.linkTip"),
                    }
                }); 
            } else {
                const validateResult = this.$refs.validLinkInput.validateLink();
                if (!validateResult) {
                    // 验证不通过直接返回
                    return;
                }
                let newPage = null;
                if (this.urlType === 'outColor' && this.linkOpenType === 'iframe') {
                    // 外部网页链接 iframe内嵌显示
                    newPage = '';
                }
                if (this.urlType === 'outColor' && this.linkOpenType === 'newPage') {
                    // 外部网页链接 新页面显示
                    newPage = 'new_page';
                }
                if (this.urlType === 'innerColor') {
                    // 游戏内跳转
                    newPage = 'custom_page';
                }
                this.data.confirm && this.data.confirm({
                    id: this.data.id || "",
                    type: this.data.type,
                    urlType: this.getUrlTtype(),
                    url: this.url,
                    word: this.word,
                    linkNewTxt: this.linkNewTxt,
                    newPage: newPage,
                });
                this.$emit('closeModal');
            }
        },
        deleteLink() {
            this.data.confirm && this.data.confirm({
                id: this.data.id || "",
                type: "delete",
                url: this.url,
                urlType: this.getUrlTtype(),
                word: this.word,
            });

            this.$emit('closeModal');
        },
        radioChange(data) {
            this.inputLinkLabel = data === 'innerColor' ? this.$t("zhiji.knowlege.linkWordModal.inputLinkLabelTwo")
            : this.$t("zhiji.knowlege.linkWordModal.inputLinkLabel");
            this.urlType = data;
        },
        linkOpenRadioChange (data) {
            this.linkOpenType = data;
        },
    }
}
</script>

<style scoped lang="less">
.link-word-modal {
    width: 100%;
    height: 100%;
    background-color: rgba(18, 22, 37, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;

    .link-word-content {
        width: 440px;
    }

    .link-word-name {
        margin-bottom: 20px;
    }

    .link-word-text {
        font-size: 14px;
        margin-bottom: 4px;
    }

    .link-radio-choose {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 12px;

        .link-color {
            background: red;
            display: inline-block;
            width: 64px;
            height: 32px;
            position: relative;
        }

        .out-color {
            left: -54px;
        }

        .inner-color {
            left: -154px;
        }

        /deep/.group-radio {
            margin-bottom: 10px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .link-word-show {
        max-height: 64px;
        background: #F2F7FB;
        border: 1px solid #D8E4F0;
        border-radius: 4px;
        padding: 4px 8px;
        box-sizing: border-box;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    .link-word-input {
        display: inline-block;
        width: 100%;
        border: 0;
    }

    .link-word-delete {
        position: absolute;
        bottom: 30px;
        cursor: pointer;
        text-decoration: underline;

        .link-delete-icon {
            vertical-align: -3px;
        }

        &:hover {
            color: #2ec2ff;
            .link-delete-icon {
                background-position: -96px -22px !important;
            }
        }
    }

    .operate-item {
        margin-top:-16px;
        margin-bottom: 15px;
        font-size: 12px;
        height: 25px;
        line-height: 25px;
        padding: 0 8px;
        cursor: pointer;
        width: 92px;
        border:1px solid #d8e4f0;
        border-radius: 4px;
    }

    .el-icon-plus:before{
        font-size: 10px;
        color: #7A7E8E;
    }
}
</style>